import React, {useEffect, useMemo, useState} from 'react';
import styled from 'styled-components';
import {fontSize, StyledID, StyledName, tabletWidth} from '../../mixins';
import {useDispatch, useSelector} from 'react-redux';
import {allUsersIDs, circlesByID, ORMCircles, ORMUsers, usersByID} from '../../app/models/ormSelectors';
import {ArrowBack, ArrowRight, PlusIcon} from '../../UI/Icons';
import {formatID} from '../../common/helper';
import Avatar from '@material-ui/core/Avatar';
import {makeStyles} from '@material-ui/core/styles';
import {getAllInvites, sendInviteFromCircleToUser} from './inviteSlice';
import {selectToken} from '../auth/authSlice';
import {selectActiveCircle} from '../dashboard/dashboardSlice';

const StyledContainer = styled.div`
  min-width: 400px;
  
  @media screen and (max-width: ${tabletWidth}) {
   min-width: unset;
  }
`

const StyledTitle = styled.p`
  ${fontSize(24)};
  line-height: 33px;
  font-weight: 800;
  color: #323232;
  mix-blend-mode: normal;
  margin-top: 0;
  margin-bottom: 34px;
  padding-left: 39px;
  
  @media screen and (max-width: ${tabletWidth}) {
    padding-right: 50px;
  }
`

const StyledBackBtn = styled.button`
  background-color: transparent;
  width: 22px;
  height: 25px;
  border: none;
  padding: 0;
  position: absolute;
  top: 19px;
  left: 20px;
  cursor: pointer;
  svg {
   width: 100%;
  } 
`

const StyledBtn = styled.button`
  background-color: transparent;
  min-width: 300px;
  border: none;
  padding: 0 0 21px 0;
  display: flex;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
  align-items: center;
  
  @media screen and (max-width: ${tabletWidth}) {
    min-width: unset;
  }
`

const StyledSingleName = styled(StyledName)`
    ${StyledName};
`

const StyledIDWrap = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  
  svg {
    margin-left: 16px;
  }
`

const StyledUserName = styled.p`
  ${fontSize(14)};
  line-height: 18px;
  color: #323232;
  margin: 0 auto 0 12px;
`

const InviteFromCircle = ({onBackClick}) => {
    const ormCircles = useSelector(ORMCircles);
    const currentCircle = useSelector(selectActiveCircle);
    const [circle, setCircle] = useState(null);
    const circleById = useSelector(circlesByID);
    const usersById = useSelector(usersByID);
    const token = useSelector(selectToken);
    const dispatch = useDispatch();

    const filterUsers = () => {
        if (circle) {
            const usersInCircle = circleById(currentCircle).members;
            const selectedCircleMembers = circleById(circle).members
            const filteredIDs = selectedCircleMembers.filter(user => !usersInCircle.includes(user));

            return usersById(filteredIDs);
        }

        return []
    }

    const userToDisplay = useMemo(() => filterUsers(), [circle]);

    const getAvailableUsers = () => {
        if (userToDisplay.length) {
            return userToDisplay.map(renderUser)
        }

        return <StyledSingleName>No users to invite</StyledSingleName>
    }

    const useStyles = makeStyles({
        avatar: {
            width: '48px',
            height: '48px',
        }
    });

    const classes = useStyles();

    const onCircleClick = (id) => () => {
        setCircle(id);
    };

    const renderCircleBtn = (i, index) => {
        const ID = formatID(i.id);

        if (i.id !== currentCircle) {
            return (
                <StyledBtn key={index} onClick={onCircleClick(i.id)}>
                    <StyledSingleName>{i.name}</StyledSingleName>
                    <StyledIDWrap>
                        <StyledID>{`ID: ${ID}`}</StyledID>
                        {ArrowRight}
                    </StyledIDWrap>
                </StyledBtn>
            )
        }

    };

    const sendInvite = (userID) => () => dispatch(sendInviteFromCircleToUser(token, currentCircle, userID));

    const renderUser = (i, index) => {
        return (
            <StyledBtn key={index} onClick={sendInvite(i.id)}>
                <Avatar alt={i.name} src={i.photo_url || '../images/default-static-avatar.png'} className={classes.avatar}/>
                <StyledUserName>{i.name}</StyledUserName>
                {PlusIcon}
            </StyledBtn>
        )
    };

    const getBackToCircles = () => setCircle(null);

    const onBackBtnClick = circle ? getBackToCircles: onBackClick;

    return (
        <StyledContainer>
            <StyledBackBtn onClick={onBackBtnClick} id='come-back-button'>{ArrowBack}</StyledBackBtn>
            <StyledTitle>Invite from Circle</StyledTitle>
            {circle ? getAvailableUsers() : ormCircles.map(renderCircleBtn)}
        </StyledContainer>
    )
};

export default InviteFromCircle;